import { markRaw } from 'vue'

import IconArchiveBox from '@/components/icons/IconArchiveBox.vue'
import IconBanknote from '@/components/icons/IconBanknote.vue'
import IconBanknotes from '@/components/icons/IconBanknotes.vue'
import IconBell from '@/components/icons/IconBell.vue'
import IconBlank from '@/components/icons/IconBlank.vue'
import IconBuilding from '@/components/icons/IconBuilding.vue'
import IconCalendar from '@/components/icons/IconCalendar.vue'
import IconCheck from '@/components/icons/IconCheck.vue'
import IconCheckbox from '@/components/icons/IconCheckbox.vue'
import IconCliboardDocument from '@/components/icons/IconCliboardDocument.vue'
import IconClock from '@/components/icons/IconClock.vue'
import IconComputer from '@/components/icons/IconComputer.vue'
import IconCpu from '@/components/icons/IconCpu.vue'
import IconCreditCard from '@/components/icons/IconCreditCard.vue'
import IconDeArchiveBox from '@/components/icons/IconDeArchiveBox.vue'
import IconDocumentCheck from '@/components/icons/IconDocumentCheck.vue'
import IconDocumentLines from '@/components/icons/IconDocumentLines.vue'
import IconDocumentText from '@/components/icons/IconDocumentText.vue'
import IconEdit from '@/components/icons/IconEdit.vue'
import IconEye from '@/components/icons/IconEye.vue'
import IconGear from '@/components/icons/IconGear.vue'
import IconGrid from '@/components/icons/IconGrid.vue'
import IconHome from '@/components/icons/IconHome.vue'
import IconKey from '@/components/icons/IconKey.vue'
import IconMail from '@/components/icons/IconMail.vue'
import IconProfile from '@/components/icons/IconProfile.vue'
import IconReport from '@/components/icons/IconReport.vue'
import IconSave from '@/components/icons/IconSave.vue'
import IconSearchCircle from '@/components/icons/IconSearchCircle.vue'
import IconShield from '@/components/icons/IconShield.vue'
import IconShoppingCart from '@/components/icons/IconShoppingCart.vue'
import IconTemplate from '@/components/icons/IconTemplate.vue'
import IconTool from '@/components/icons/IconTool.vue'
import IconTrash from '@/components/icons/IconTrash.vue'
import IconTrendingUp from '@/components/icons/IconTrendingUp.vue'
import IconUser from '@/components/icons/IconUser.vue'
import IconUsers from '@/components/icons/IconUsers.vue'
import IconWarning from '@/components/icons/IconWarning.vue'
import IconWrench from '@/components/icons/IconWrench.vue'

/** Fallback when `id` is missing or unknown. */
export const DEFAULT_ICON = markRaw(IconBlank)

/**
 * Icons the category editor offers. Order is the picker grid order.
 * `id` matches server `category.icon.name` for direct lookup.
 */
export const AVAILABLE_ICONS = Object.freeze([
  { id: 'archive-box', label: 'Archive', component: markRaw(IconArchiveBox) },
  { id: 'de-archive-box', label: 'Restore from archive', component: markRaw(IconDeArchiveBox) },
  { id: 'banknote', label: 'Banknote', component: markRaw(IconBanknote) },
  { id: 'banknotes', label: 'Banknotes', component: markRaw(IconBanknotes) },
  { id: 'bell', label: 'Bell', component: markRaw(IconBell) },
  { id: 'building', label: 'Building', component: markRaw(IconBuilding) },
  { id: 'calendar', label: 'Calendar', component: markRaw(IconCalendar) },
  { id: 'checkbox', label: 'Checkbox', component: markRaw(IconCheckbox) },
  { id: 'check', label: 'Check', component: markRaw(IconCheck) },
  { id: 'clipboard', label: 'Clipboard', component: markRaw(IconCliboardDocument) },
  { id: 'clock', label: 'Clock', component: markRaw(IconClock) },
  { id: 'computer', label: 'Computer', component: markRaw(IconComputer) },
  { id: 'cpu', label: 'CPU', component: markRaw(IconCpu) },
  { id: 'credit-card', label: 'Credit Card', component: markRaw(IconCreditCard) },
  { id: 'document-check', label: 'Document Check', component: markRaw(IconDocumentCheck) },
  { id: 'document-lines', label: 'Document Lines', component: markRaw(IconDocumentLines) },
  { id: 'document-text', label: 'Document Text', component: markRaw(IconDocumentText) },
  { id: 'edit', label: 'Edit', component: markRaw(IconEdit) },
  { id: 'eye', label: 'Eye', component: markRaw(IconEye) },
  { id: 'gear', label: 'Gear', component: markRaw(IconGear) },
  { id: 'grid', label: 'Grid', component: markRaw(IconGrid) },
  { id: 'home', label: 'Home', component: markRaw(IconHome) },
  { id: 'key', label: 'Key', component: markRaw(IconKey) },
  { id: 'mail', label: 'Mail', component: markRaw(IconMail) },
  { id: 'profile', label: 'Profile', component: markRaw(IconProfile) },
  { id: 'report', label: 'Report', component: markRaw(IconReport) },
  { id: 'save', label: 'Save', component: markRaw(IconSave) },
  { id: 'search', label: 'Search', component: markRaw(IconSearchCircle) },
  { id: 'shield', label: 'Shield', component: markRaw(IconShield) },
  { id: 'shopping-cart', label: 'Shopping Cart', component: markRaw(IconShoppingCart) },
  { id: 'template', label: 'Template', component: markRaw(IconTemplate) },
  { id: 'tool', label: 'Tool', component: markRaw(IconTool) },
  { id: 'trash', label: 'Trash', component: markRaw(IconTrash) },
  { id: 'trending-up', label: 'Trending Up', component: markRaw(IconTrendingUp) },
  { id: 'user', label: 'User', component: markRaw(IconUser) },
  { id: 'users', label: 'Users', component: markRaw(IconUsers) },
  { id: 'warning', label: 'Warning', component: markRaw(IconWarning) },
  { id: 'wrench', label: 'Wrench', component: markRaw(IconWrench) },
])

/** Id → Vue component lookup for `iconUtility.get`. */
export const AVAILABLE_ICONS_MAP = new Map(AVAILABLE_ICONS.map((icon) => [icon.id, icon.component]))
